import { Data } from "effect"

export type Outcome<A, E> = Data.TaggedEnum<{
  Success: { value: A }
  Failure: { reasons: Array<string>; fields: E }
}>

interface OutcomeDefinition extends Data.TaggedEnum.WithGenerics<2> {
  readonly taggedEnum: Outcome<this["A"], this["B"]>
}

export namespace Outcome {
  const _Outcome = Data.taggedEnum<OutcomeDefinition>()

  export type Success<A> = Data.TaggedEnum.Value<Outcome<A, unknown>, "Success">
  export type Failure<E> = Data.TaggedEnum.Value<Outcome<unknown, E>, "Failure">

  export const match = _Outcome.$match

  export const isFailure = _Outcome.$is("Failure")
  export const isSuccess = _Outcome.$is("Success")

  export const Success = <A>(value: A) => _Outcome.Success({ value })

  export const Failure = <E>(reasons: Array<string>, fields: E) =>
    _Outcome.Failure({ reasons, fields })
}
